<template>
    <b-container>
        <b-card v-if="!token">
            <b-card-header>
                <b>Temporäres Upload-Token erstellen</b>
            </b-card-header>

            <b-card-body>
                <b-form @submit.prevent="createTmpUploadToken">
                    <b-form-group
                        label="Vorname Kunde"
                        label-for="inputFirstCustomer"
                    >
                        <b-form-input id="inputFirstCustomer" type="text" v-model="firstName"></b-form-input>
                    </b-form-group>

                    <b-form-group
                        label="Nachname Kunde"
                        label-for="inputLastCustomer"
                    >
                        <b-form-input id="inputLastCustomer" type="text" v-model="lastName"></b-form-input>
                    </b-form-group>

                    <b-form-group
                        label="Mitarbeiter"
                        label-for="inputEmployees"
                    >
                        <multiselect
                                     id="inputEmployees"
                                     v-model="selectedMembers"
                                     :options="members"
                                     :multiple="true"
                                     v-bind:placeholder="$globalStore.translate('home.employees.placeholder')"
                                     v-bind:selectLabel="$globalStore.translate('home.selection.select.label')"
                                     v-bind:selectedLabel="$globalStore.translate('home.selection.selected.label')"
                                     v-bind:selectGroupLabel="$globalStore.translate('home.selection.select.group.label')"
                                     v-bind:deselectLabel="$globalStore.translate('home.selection.deselect.label')"
                                     v-bind:deselectGroupLabel="$globalStore.translate('home.selection.deselect.group.label')"
                                     v-on:open="loadEmployees"

                        >
                        </multiselect>
                    </b-form-group>

                    <p>Sie werden automatisch zugewiesen und müssen sich nicht auswählen.</p>

                    <b-form-group
                        label="Projektgruppe"
                        label-for="inputProjectGroups"
                    >
                        <multiselect
                            id="inputProjectGroups"
                            v-model="selectedProjectGroup"
                            :options="projectGroups"
                            :multiple="false"
                            :disabled="projectGroups.length === 0"
                            v-bind:placeholder="$globalStore.translate('home.project.groups.placeholder')"
                            v-bind:selectLabel="$globalStore.translate('home.selection.select.label')"
                            v-bind:selectedLabel="$globalStore.translate('home.selection.selected.label')"
                            v-bind:selectGroupLabel="$globalStore.translate('home.selection.select.group.label')"
                            v-bind:deselectLabel="$globalStore.translate('home.selection.deselect.label')"
                            v-bind:deselectGroupLabel="$globalStore.translate('home.selection.deselect.group.label')"
                            v-on:open="loadProjectGroups"

                        >
                        </multiselect>
                    </b-form-group>

                    <b-button type="submit" variant="primary" class="float-right">Erstellen</b-button>
                </b-form>
            </b-card-body>
        </b-card>
        <b-card v-else>
            <b-card-header>
                <b>Token erfolgreich erstellt</b>
            </b-card-header>

            <b-card-body>
                Kunden können über folgenden temporären Link (7 Tage gültig) Dateien hochladen:<br>
                <a :href="'https://drop.rautec.de/upload/' + token">https://drop.rautec.de/upload/{{ token }}</a>

                <b-button variant="primary" class="float-right" @click="resetForm">Fertig</b-button>
            </b-card-body>
        </b-card>
    </b-container>
</template>

<script>
    import axios from 'axios'
    import Multiselect from 'vue-multiselect'

    export default {
        name: "TmpUpload",
        components: { Multiselect },
        data() {
            return {
                members: [],
                selectedMembers: [],
                projectGroups: [],
                selectedProjectGroup: '',
                firstName: '',
                lastName: '',
                token: null
            }
        },
        methods: {
            createTmpUploadToken: function () {
                if (!this.firstName || !this.lastName) {
                    return;
                }

                let formData = new FormData();
                formData.append('projectGroup', this.selectedProjectGroup);
                formData.append('firstName', this.firstName);
                formData.append('lastName', this.lastName);
                for (let i = 0; i < this.selectedMembers.length; i++) {
                    formData.append('members[' + i + ']', this.selectedMembers[i]);
                }

                axios.post('https://drop.rautec.de/api/tmpUploadTokens', formData).then(response => {
                    if (response.data.success) {
                        this.token = response.data.token;
                    }
                });
            },
            resetForm: function () {
                this.firstName = '';
                this.lastName = '';
                this.selectedMembers = [];
                this.selectedProjectGroup = '';
                this.token = '';
            },
            loadEmployees: function () {
                if (this.members.length === 0) {
                    axios.get('https://drop.rautec.de/api/users/employees').then(response => {
                        if (response.data.employees) {
                            this.members = this.members.concat(response.data.employees);
                        }
                    });
                }
            },
            loadProjectGroups: function () {
                axios.get('https://drop.rautec.de/api/projectGroups/all').then(response => {
                    if (response.data.projectGroups) {
                        this.projectGroups = response.data.projectGroups;
                    }
                });
            }
        },
        mounted() {
            this.loadProjectGroups();
            this.loadEmployees();
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/TmpUpload.vue